import posthog from 'posthog-js';

export default {
  install: (app) => {
    if (process.env.NODE_ENV === 'production') {
      posthog.init(process.env.VUE_APP_NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://app.posthog.com',
        autocapture: true,
      });
    }

    // Attach to global properties regardless, so calls won't break
    app.config.globalProperties.$posthog = posthog;
  }
}
